















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HubComponent extends Vue {
	/*@Prop({
		default: 'foo'
	}) private title!: string;*/

	private linkList: Array<{
		url: string,
		color: string,
		icon: string,
		text: string
	}> = [
			{
				url: 'https://github.com/Crylion',
				color: '110, 84, 148',
				icon: 'icon-github-white',
				text: 'My Github profile'
			},
			{
				url: 'https://www.instagram.com/crylion/',
				color: '247,119,55',
				icon: 'icon-instagram-white',
				text: 'A few of my hobby photography pictures'
			},
			{
				url: 'https://www.projektionisten.de',
				color: '187, 187, 187',
				icon: 'icon-briefcase-white',
				text: 'My current workplace'
			}
		];
}
